import axios from 'axios'

/** Rolodex answers 401, 403, or 404 when the caller cannot read a scope; callers treat that as no grants. */
export function isMissingAccessError(error: unknown): boolean {
  return (
    axios.isAxiosError(error) &&
    [401, 403, 404].includes(error.response?.status ?? 0)
  )
}
